module.exports = {"__schema":{"types":[]}}


//////////////////
// WEBPACK FOOTER
// ./src/fragmentTypes.json
// module id = 1617
// module chunks = 1